import type React from 'react';

import { SkeletonImage } from '@xing-com/skeleton';
import { scale380 } from '@xing-com/tokens';

export const PreviewSkeleton: React.FC = () => (
  <SkeletonImage variant="primary" height={scale380} />
);
